import _ from 'lodash';
import { constantsActive } from 'utils/constants/constants';
import { roomConstants } from 'utils/constants/room-constants';

export function dashboardMeetingRooms(building, floors, rooms, now, showAllTimeslots) {
	const result = [];
	for( const floor of building?.floors ?? [] ) {
		for( const reference of floors?.[floor.guid]?.rooms ?? [] ) {
			const room = rooms?.[reference.guid];
			if( room?.active !== constantsActive.YES || room.kind !== roomConstants.KIND_MEETING_ROOM ) {
				continue;
			}
			const allTimeslots = _.orderBy(_.filter(room.timeslots_through, { timeslot_day: now.day() }), ['timeslot_start'], ['asc']);
			const start = now.subtract(90, 'minutes');
			const end = now.add(150, 'minutes');
			const timeslots = allTimeslots.filter( ( slot ) => {
				const slotEnd = now.startOf('day').add(Number(slot.timeslot_end.substr(0, 2)), 'hours').add(Number(slot.timeslot_end.substr(3, 2)), 'minutes');
				return showAllTimeslots || (slotEnd.valueOf() >= start.valueOf() && slotEnd.valueOf() <= end.valueOf());
			});
			result.push({ ...room, building, floor, all_timeslots: allTimeslots, timeslots_through: allTimeslots, timeslots });
		}
	}
	return result;
}

export function dashboardBookings(result) {
	const bookings = {};
	for( const [ key, value ] of Object.entries(result ?? {}) ) {
		const room = key.split('--').find( ( part ) => {
			return part.startsWith('r:');
		})?.slice(2);
		const slot = key.split('--').find( ( part ) => {
			return part.startsWith('ts:');
		})?.slice(3);
		if( room && slot ) {
			bookings[room] = { ...bookings[room], [slot]: value };
		}
	}
	return bookings;
}

export function meetingTimeslots(timeslot, timeslots, bookings) {
	const invitation = bookings?.[timeslot.guid]?.[0]?.booking_invitation?.guid;
	if( !invitation ) {
		return [ timeslot ];
	}
	const groups = [];
	for( const slot of _.orderBy(timeslots, ['timeslot_start'], ['asc']) ) {
		if( bookings?.[slot.guid]?.[0]?.booking_invitation?.guid !== invitation ) {
			continue;
		}
		const previous = groups[groups.length - 1];
		if( previous && previous[previous.length - 1].timeslot_end === slot.timeslot_start ) {
			previous.push(slot);
		} else {
			groups.push([ slot ]);
		}
	}
	return groups.find( ( group ) => {
		return group.some( ( slot ) => {
			return slot.guid === timeslot.guid;
		});
	}) ?? [ timeslot ];
}

export function isTimeslotActive(now, timeslot) {
	const time = now.format('HH:mm');
	return time >= timeslot.timeslot_start.substr(0, 5) && time < timeslot.timeslot_end.substr(0, 5);
}
